module.exports = __webpack_public_path__ + "img/shape-8-mobile@2x.235e1e94.png";